import React from "react";
import { roundMoneyValue } from "../../../../utils/functions";
import { calculateAdditionalMealsQuantity, calculateMealPriceAccordingToTotals, getActualMealTypeQuantity, getDietType } from './../utils/functions';

function AdditionalMeals(props) {
    const {
        bundles,
        programType,
        selectedBreakfastsQuantity,
        selectedEntreesQuantity,
        dietType,
        limitations,
        selectedMeals
    } = props;

    if (programType !== "Program") return null;

    const breakfastType = getDietType("Breakfasts", dietType);
    const entreesType = getDietType("Entrées", dietType);

    const actualBreakfastsQuantity = getActualMealTypeQuantity(limitations, breakfastType, selectedMeals);
    const actualEntreesQuantity = getActualMealTypeQuantity(limitations, entreesType, selectedMeals);

    const breakfastPrice = calculateMealPriceAccordingToTotals(actualBreakfastsQuantity, selectedBreakfastsQuantity, limitations.breakfastsMinLimit, 'Breakfasts', dietType, bundles);

    const entreePrice = calculateMealPriceAccordingToTotals(actualEntreesQuantity, selectedEntreesQuantity, limitations.entreesMinLimit, 'Entrées', dietType, bundles);

    const { additionalBreakfastsQuantity,
        additionalEntreesQuantity
    } = calculateAdditionalMealsQuantity(selectedBreakfastsQuantity, selectedEntreesQuantity, limitations);

    const computeAdditionalsPrice = () => {
        return roundMoneyValue(
            breakfastPrice * additionalBreakfastsQuantity +
            entreePrice * additionalEntreesQuantity
        )
    };

    const isAdditionalsAvailable = () => {
        return (additionalBreakfastsQuantity > 0 ||
            additionalEntreesQuantity > 0);
    }

    let additionalsPrice = computeAdditionalsPrice();

    return (
        <>
            {(isAdditionalsAvailable()) && (
                <>
                    <div className="product-nav__title">
                        Additional Meals
                    </div>
                    <dl className="price">
                        <div className="price__regular">
                            <dd>
                                <span className="price-item price-item--regular">
                                    ${additionalsPrice}
                                </span>
                            </dd>
                        </div>
                    </dl>{" "}
                </>
            )}
        </>
    );
}

export default AdditionalMeals;